const React = require('react');
const { I18nextProvider } = require('react-i18next');
const i18n = require('./src/i18n');

exports.onClientEntry = () => {
  const locale = document.body.dataset.locale;

  const utmCampaign = new URLSearchParams(window.location.search).get('utm_campaign');

  if (utmCampaign) {
    sessionStorage.setItem('utm_campaign', utmCampaign);
  }

  if (locale) {
    i18n.default.changeLanguage(locale);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');

    const campaign = sessionStorage.getItem('utm_campaign');

    if (link && link.href && link.href.includes('app.klang.ai') && campaign) {

      const url = new URL(link.href);

      url.searchParams.set('utm_campaign', campaign);

      const newUrl = url.toString();

      event.preventDefault();
      window.location.href = newUrl;
    }
  });
};

exports.wrapRootElement = ({ element }) => {
  return React.createElement(
    I18nextProvider,
    { i18n: i18n.default },
    element
  );
};
